import { useState, useEffect } from "react";
import { Route, Redirect, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import OutsideLayout from "../layouts/OutsideLayout";

function PublicRoute({ component: Component, ...rest }) {
  const location = useLocation();
  const [redirectUrl, setRedirectUrl] = useState("");
  const storedUser = localStorage.getItem("user");
  let parsedUser = {};
  if (storedUser) {
    try {
      parsedUser = JSON.parse(storedUser);
    } catch (e) {
      parsedUser = {};
    }
  }

  useEffect(() => {
    const redirect = location.search.match(/redirect=(.+)/);
    if (redirect?.length) {
      setRedirectUrl(redirect[1]);
    }
  }, [location]);

  const { isAuth } = useSelector((state) => state.user);
  const defaultRedirect =
    parsedUser?.account_type === "enterprise"
      ? parsedUser?.role === "cytailor_admin"
        ? "/super_admin_management"
        : "/enterprise"
      : "/quizzes";

  return (
    <Route
      {...rest}
      component={(props) =>
        isAuth ? (
          redirectUrl ? (
            <Redirect to={redirectUrl} />
          ) : (
            <Redirect to={defaultRedirect} />
          )
        ) : (
          <OutsideLayout>
            <Component {...props} />
          </OutsideLayout>
        )
      }
    />
  );
}

export default PublicRoute;
